import {t} from '@eitje/bridge'

export const formatBoolean = value => {
	if (value == 'no' || !value) return t('common.no')
	return t('common.yes')
}

export const BooleanCell = ({getValue}) => {
	return formatBoolean(getValue())
}
